//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { QDialog } from "quasar";
import AQButton from "../AQButton/AQButton.vue";
import AQMenu from "../AQMenu/AQMenu.vue";
import AQTooltip from "../AQTooltip/AQTooltip.vue";

export default {
    name: "AQModal",
    components: {
        QDialog,
        AQButton,
        AQMenu,
        AQTooltip
    },
    props: {
        value: { type: Boolean, default: false },
        title: { type: String, default: "" },
        atId: { type: String, default: "" },
        size: { type: String, default: "" }, // big, small, xsmall or full
        primary: { type: Object, default: () => {} },
        secondary: { type: Object, default: () => {} },
        save: { type: Object, default: () => {} },
        moreOptionsDisabled: { type: Boolean, default: false },
        headerActions: { type: Array, default: () => [] },
        position: { type: String, default: "right" }, // top, right, bottom, left
        hideClose: { type: Boolean, default: false },
        backgroundWhite: { type: Boolean, default: false },
        noBackdropDismiss: { type: Boolean, default: true },
        isSmallScreen: { type: Boolean, default: false },
        maximized: { type: Boolean, default: false },
        persistent: { type: Boolean, default: false },
        saveTooltipContent: { type: String, default: "" },
        direction: { type: String, default: "left" },
        contentClass: { type: String, default: "" } // it is used when it is necessary to overwrite the class "modal-layout"
    },
    data() {
        return {
            showMenu: [],
            count: 1
        };
    },
    computed: {
        getContentClass() {
            return `${this.contentClass || "modal-layout"} ${this.backgroundWhite ? "bg-white" : ""}`;
        },
        hasSaveTooltip() {
            return this.tooltipContent;
        },
        getWidth() {
            let width = "720px";
            switch (this.size) {
                case "big":
                    width = "960px";
                    break;
                case "small":
                    width = "360px";
                    break;
                case "xsmall":
                    width = "300px";
                    break;
                case "full":
                    width = "100vw";
                    break;
                default:
                    width = "720px";
            }
            return width;
        },
        getAtId() {
            return this.atId ? `${this.atId}-modal-id` : "modal-id";
        },
        getSaveAtId() {
            return this.atId ? `${this.atId}-save-btn` : "save-btn";
        },
        getPrimaryAtId() {
            return this.atId ? `${this.atId}-primary-btn` : "primary-btn";
        },
        getSecondaryAtId() {
            return this.atId ? `${this.atId}-secondary-btn` : "secondary-btn";
        },
        getHeaderActionsAtId() {
            return this.atId ? `${this.atId}-more-actions` : "more-actions";
        },
        getCloseBtnAtId() {
            return this.atId ? `${this.atId}-close-btn` : "close-btn";
        }
    },
    watch: {
        showMenu: {
            handler(val) {
                if (val && val.length) {
                    this.emitAction(val[0].label);
                }
            }
        }
    },
    mounted() {
        setTimeout(() => {
            const backdrops = document.querySelectorAll(".q-dialog__backdrop");
            const modals = document.querySelectorAll(".modal-layout");
            backdrops[modals.length - 1].addEventListener("mousedown", this.onClickBackdrop);
            this.modalsNumber = modals.length;
            modals[modals.length - 1].setAttribute("startWidth", this.getWidth);
            for (let i = modals.length - 1; i > 0; i--) {
                if (modals[i].style.minWidth === modals[i - 1].style.minWidth) {
                    modals[i - 1].style.minWidth = `${parseInt(modals[i - 1].style.minWidth.replace("px", ""), 10) + 56}px`;
                }
            }
        }, 100);
    },
    beforeDestroy() {
        const modals = document.querySelectorAll(".modal-layout");
        const backdrops = document.querySelectorAll(".q-dialog__backdrop");
        this.shrinkModals(modals);
        backdrops[modals.length - 1].removeEventListener("mousedown", this.onClickBackdrop);
        this.$emit("input", false);
        this.$emit("afterHide");
    },
    methods: {
        setValue(show) {
            this.$emit("input", show);
        },
        modalShow() {
            this.$emit("input", true);
            if (this.noBackdropDismiss) {
                const closeButtons = document.getElementsByClassName("close-icon");
                if (closeButtons[closeButtons.length - 1].classList.contains("animate-flicker")) {
                    closeButtons[closeButtons.length - 1].classList.remove("animate-flicker");
                }
            }
            this.$emit("afterShow");
        },
        emitAction(actionName) {
            this.$emit("action", actionName);
        },
        onClickBackdrop() {
            if (this.noBackdropDismiss) {
                const closeButtons = document.getElementsByClassName("close-icon");
                closeButtons[closeButtons.length - 1].classList.add("animate-flicker");
                setTimeout(() => {
                    if (closeButtons.length) {
                        closeButtons[closeButtons.length - 1].classList.remove("animate-flicker");
                    }
                }, 300);
            }
            this.emitAction("backdrop");
        },
        shrinkModals(modals) {
            for (let i = modals.length - 1; i > 0; i--) {
                if (parseInt(modals[i].style.minWidth.replace("px", ""), 10) + (56 * this.count)
                    === parseInt(modals[i - 1].style.minWidth.replace("px", ""), 10)) {
                    modals[i - 1].style.minWidth = `${parseInt(modals[i - 1].style.minWidth.replace("px", ""), 10) - 56}px`;
                    this.count = 2;
                } else {
                    break;
                }
            }
        }
    }
};
